import React from 'react'
import "./css/Projects.css"
import "./css/Projects.css"
import AOS from 'aos';
function Project({name,created_at, clone_url,location,description,language}) {
    AOS.init();
    const time=created_at.substring(0,10)
    return (
        <a data-aos="fade-up"  
        data-aos-duration="3000" href={clone_url}><article  className="article">
            <div className="up_part"><img  src={location} alt=""/></div>
            <div className="info_part">
                <h4>{name}</h4>
                <p>{description}</p>
                <p>{language}</p>
                <time>{time}</time>

            </div>
        </article></a>
    )
}

export default Project
